import React, {PropTypes as T} from 'react';
import AdditionalInfoContent from './additional_info_content';
import SpecialInfoContent from './special_info_modal_content';

const SeatmapMessage = function (props) {
  const {modal} = props;

  function setBodyOverflow () {
    document.body.style.overflow = (modal.showModalOnLoad || modal.showModal) ? 'hidden' : '';
  }

  if (modal.informationLightbox &&
    modal.showModalOnLoad &&
    modal.informationLightbox.infoTopics &&
    modal.informationLightbox.infoTopics.length > 0) {
    setBodyOverflow();
    return <AdditionalInfoContent modal={modal} />;
  }
  else if (props.showModal) {
    setBodyOverflow();
    return (
      <SpecialInfoContent
        {...props}
        modal={modal} />
    );
  }
  else {
    return <noscript />;
  }
};

SeatmapMessage.propTypes = {
  modal: T.object,
  showModal: T.bool
};

export default SeatmapMessage;



// WEBPACK FOOTER //
// ./frontend/react/components/edp/messages/index.js